export const calcFailPct = (total, fails) =>
    total > 0 ? ((fails / total) * 100).toFixed(1) : 0;
